import React, { useEffect, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import styled from 'styled-components';

import animationData from '@/assets/icons/congratulations.json';

interface Props {
  originRect: DOMRect;
  onComplete: () => void;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
`;

const AnimationWrapper = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  width: 320px;
  height: 320px;
  left: ${({ $x }) => $x - 160}px;
  top: ${({ $y }) => $y - 160}px;
  pointer-events: none;
`;

const ConfettiAnimation: React.FC<Props> = ({ originRect, onComplete }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const cx = originRect.left + originRect.width / 2;
  const cy = originRect.top + originRect.height / 2;

  useEffect(() => {
    lottieRef.current?.play();
  }, []);

  useEffect(() => {
    return () => {
      onComplete();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Overlay>
      <AnimationWrapper $x={cx} $y={cy}>
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop={false}
          autoplay
          onComplete={onComplete}
          style={{ width: '100%', height: '100%' }}
        />
      </AnimationWrapper>
    </Overlay>
  );
};

export default ConfettiAnimation;
